import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { readRole } from '../api'
import { RoleFormModel } from '../typings'
import { unwrapResult } from '@reduxjs/toolkit'

export const useReadRole = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const [toFetch, setToFetch] = useState<number>()
  const [role, setRole] = useState<RoleFormModel>()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (toFetch) {
        try {
          setStatus('pending')
          const result = await dispatch(readRole(toFetch))
          if (mounted) {
            if (readRole.fulfilled.match(result)) {
              unwrapResult(result)
              setRole(result.payload)
              setStatus('success')
            } else {
              setStatus('success')
            }
          }
        } catch {
          if (mounted) setStatus('fail')
        } finally {
          if (mounted) {
            setToFetch(undefined)
          }
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, toFetch])

  return { status, execute: setToFetch, role }
}
